import { AfterViewInit, Component, ElementRef, inject, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import MetisMenu from 'metismenujs';
import { SimplebarAngularModule } from 'simplebar-angular';

import { MenuItem } from './menu.model';
import { EventService } from 'src/app/core/services/event.service';
import { ValidatorsService } from '../../services/validators.service';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, SimplebarAngularModule],
  templateUrl: './sidebar.component.html',
  styles: [],
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef: any;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  MENU: MenuItem[] = [
    {
      id: 1,
      label: 'MENUITEMS.DASHBOARDS.TEXT',
      role: 'ADMIN',
      isTitle: true
    },
    {
      id: 2,
      label: 'MENUITEMS.HOME.TEXT',
      icon: 'fas fa-house',
      role: 'ADMIN',
      link: '/dashboard/home',
    },
    {
      id: 6,
      isLayout: true,
      role: 'ADMIN',
    },
    {
      id: 13,
      name: 'FACTURACIÓN',
      label: 'MENUITEMS.FACTURACION.TEXT',
      role: ['ADMIN', 'SELLER'],
      isTitle: true
    },
    {
      id: 14,
      label: 'MENUITEMS.CLIENTES.TEXT',
      icon: 'fas fa-users',
      role: ['ADMIN', 'SELLER'],
      link: '/invoices/clients',
    },
    {
      id: 15,
      label: 'MENUITEMS.FACTURAR.TEXT',
      icon: 'fas fa-file-invoice',
      role: ['ADMIN', 'SELLER'],
      link: '/invoices/invoice',
    },
    {
      id: 15,
      label: 'MENUITEMS.SEARCHFACTURAS.TEXT',
      icon: 'fas fa-list',
      role: ['ADMIN', 'SELLER'],
      link: '/invoices/invoice-query',
    },
    {
      id: 115,
      label: 'MENUITEMS.OBSERVEDINVOICES.TEXT',
      icon: 'fas fa-eye',
      role: 'ADMIN',
      link: '/invoices/observed-invoices',
    },
    {
      id: 16,
      label: 'MENUITEMS.SEARCHFACTURASMINOR.TEXT',
      icon: 'fas fa-file-invoice',
      role: 'ADMIN',
      link: '/invoices/invoice-query-minor',
    },
    {
      id: 17,
      label: 'MENUITEMS.PRODUCTOS.TEXT',
      icon: 'fas fa-shopping-cart',
      role: 'ADMIN',
      link: '/invoices/products',
    },
    {
      id: 32,
      name: 'ADMINISTRACION',
      label: 'MENUITEMS.GESTION.TEXT',
      role: 'ADMIN',
      icon: 'fas fa-gears',
      subItems: [
        {
          id: 33,
          name: 'SINCRONIZACION',
          role: 'ADMIN',
          label: 'MENUITEMS.GESTION.LIST.SINCRONIZACION',
          link: '/management/synchronization',
          parentId: 92
        },
        {
          id: 34,
          name: 'CAF',
          role: 'ADMIN',
          label: 'MENUITEMS.GESTION.LIST.CAF',
          link: '/management/caf',
          parentId: 92
        },
        {
          id: 35,
          name: 'PERFIL',
          role: 'ADMIN',
          label: 'HEADER.LOGIN.PROFILE',
          link: '/management/profile',
          parentId: 92
        },
        {
          id: 36,
          name: 'USUARIOS',
          role: 'ADMIN',
          label: 'MENUITEMS.GESTION.LIST.CHILD-USER',
          link: '/management/child-user',
          parentId: 92
        },
      ]
    },
    {
      id: 26,
      name: 'ADMINISTRACION_TITULO',
      label: 'MENUITEMS.ADMINISTRACION.TEXT',
      isTitle: true
    },
    {
      id: 32,
      label: 'MENUITEMS.CUSTOMERS.TEXT',
      icon: 'fas fa-address-book',
      role: 'SUPER_ADMIN',
      link: '/backoffice/customers',
    },
    {
      id: 33,
      label: 'MENUITEMS.COMPANIES.TEXT',
      icon: 'fas fa-building',
      role: 'SUPER_ADMIN',
      link: '/backoffice/companies',
    },
    {
      id: 35,
      label: 'MENUITEMS.USERS.TEXT',
      icon: 'fas fa-users',
      role: 'SUPER_ADMIN',
      link: '/backoffice/users',
    },
    {
      id: 35,
      label: 'MENUITEMS.SUBSCRIPTIONS.TEXT',
      icon: 'fas fa-calendar-alt',
      role: 'SUPER_ADMIN',
      link: '/backoffice/subscriptions',
    },
    {
      id: 36,
      label: 'MENUITEMS.UNVERIFIEDINVOICES.TEXT',
      icon: 'fas fa-exclamation-triangle',
      role: 'SUPER_ADMIN',
      link: '/backoffice/unverified-invoices',
    },
    {
      id: 2,
      label: 'MENUITEMS.ACERCADE.TEXT',
      icon: 'fa fa-info-circle',
      link: '/acerca-de',
    },
  ];
  menuItems: MenuItem[] = [];

  @ViewChild('sideMenu') sideMenu?: ElementRef;
  authService = inject(AuthService);
  router = inject(Router);
  eventService = inject(EventService);
  translate = inject(TranslateService);
  validatorsService = inject(ValidatorsService);

  constructor() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu!.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event: any) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        if (this.sideMenu) {
          this.menu = new MetisMenu(this.sideMenu.nativeElement);
        }
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        let currentPosition: any = document.getElementsByClassName("mm-active")[0];
        currentPosition = currentPosition['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef && this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      let link: any = links[i];
      paths.push(link['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl: any = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = [...this.MENU];
    //**Select si tiene permisos por modulo view | true | false */
    this.menuItems.forEach((item) => {
      const userRole = this.authService._user()?.role.name as string;
      const roles = Array.isArray(item.role) ? item.role : [item.role];

      if (roles.includes(userRole)) {
        item.view = true
      } else {
        if (!item.role) {
          item.view = true;
        } else {
          item.view = false;
        }
      }
      item?.subItems?.forEach((subItem: any) => {
        const subRoles = Array.isArray(subItem.role) ? subItem.role : [subItem.role];
        if (subRoles.includes(userRole)) {
          subItem.view = true
        } else {
          if (!subItem.role) {
            subItem.view = true;
          } else {
            subItem.view = false;
          }
        }
      });
    });

    //**los que no tienen permiso estan falso entonces lo filtramos */
    this.menuItems?.forEach(item => {
      if (item?.subItems) {
        item!.subItems = item?.subItems.filter((item: any) => item.view);
      }
    });

    this.menuItems = this.menuItems.filter(item => item.view);
  }

  checkBooleanArray(array: boolean[]): boolean {
    // Verificar si al menos hay un verdadero (true) en el arreglo
    const atLeastOneTrue = array.some(value => value === true);
    return atLeastOneTrue;
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
